import { render, staticRenderFns } from "./emergencyContactyzm.vue?vue&type=template&id=97504328&scoped=true"
import script from "./emergencyContactyzm.vue?vue&type=script&lang=js"
export * from "./emergencyContactyzm.vue?vue&type=script&lang=js"
import style0 from "./emergencyContactyzm.vue?vue&type=style&index=0&id=97504328&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97504328",
  null
  
)

export default component.exports